export default __webpack_public_path__ + "static/6-css-diner-e07a2f1eddd7a7056468a51048b7914a.jpeg";